module.exports = __webpack_public_path__ + "37a2cd0146036fb94f17c03fc0aa6693.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/googley-7.png
// module id = 1515
// module chunks = 0